import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'list_form';
export const useCreateListFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  list_form: {
    title_create: 'Создать список',
    title_update: 'Изменить список',
    user_data: {
      label: 'Название',
      placeholder: '',
    },
    owner_department_hint: 'Чтобы изменить подразделение владельца, перейдите в раздел “Управление доступом” или обратитесь к администратору.',
    submit_create: 'Создать',
    submit_update: 'Сохранить',
    cancel: 'Отмена',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  list_form: {
    title_create: 'Create list',
    title_update: 'Edit list',
    user_data: {
      label: 'Name',
      placeholder: '',
    },
    owner_department_hint: 'To change the owner department, go to Access management or contact your administrator.',
    submit_create: 'Create',
    submit_update: 'Save',
    cancel: 'Cancel',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  list_form: {
    title_create: 'Crie uma lista',
    title_update: 'Editar lista',
    user_data: {
      label: 'Nome',
      placeholder: '',
    },
    owner_department_hint: 'Para alterar o departamento proprietário, acesse o gerenciamento de acesso ou entre em contato com o administrador.',
    submit_create: 'Criar',
    submit_update: 'Salvar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  list_form: {
    title_create: 'Crear una lista',
    title_update: 'Editar lista',
    user_data: {
      label: 'Nombre',
      placeholder: '',
    },
    owner_department_hint: 'Para cambiar el departamento propietario, vaya a la gestión de acceso o póngase en contacto con el administrador.',
    submit_create: 'Crear',
    submit_update: 'Ahorrar',
    cancel: 'Cancelar',
  },
}) : {}) as Record<string, unknown>;
